export const mutateCreateAnimal = `mutation MyMutation (
  $StudyID: String!,
  $Stain: String,
  $Sex: String,
  $SacrificePeriod: String,
  $Group: String,
  $Dose: String,
  $AnimalName: String,
  $Administration: String
) {
  createAnimal(animal: {
    StudyID: $StudyID, 
    Stain: $Stain, 
    Sex: $Sex, 
    SacrificePeriod: $SacrificePeriod, 
    Group: $Group, 
    Dose: $Dose, 
    AnimalName: $AnimalName, 
    Administration: $Administration
  }) {
    Administration
    AnimalName
    Dose
    Group
    ID
    SacrificePeriod
    Sex
    Stain
    StudyID
  }
}`;

export const getAnimals = `query MyQuery ($id: String!, $page: Int, $pageSize: Int) {
  getAnimals(id: $id, page: $page, pageSize: $pageSize) {
    ID
    AnimalName
    Group
    SacrificePeriod
    Dose
    Administration
    Stain
    Sex
    StudyID
    Slides {
      AnimalID
      Block
      ControlGroup
      Dzi
      ID
      ImageFileName
      Magnification
      Organ
      Scanner
      Set
      SlideName
      StudyID
      SlideStatus
      SlideObservation {
        Directionality
        Finding
        FindingInhand
        ID
        Laterality
        ServerityInhand
        Severity
        SlideID
      }
      SlideNote {
        Directionality
        Finding
        FindingInhand
        ID
        Laterality
        ServerityInhand
        SlideID
        Severity
      }
      InterimSlideNote {
        Directionality
        Finding
        FindingInhand
        ID
        Laterality
        ServerityInhand
        Severity
        SlideID
      }
    }
  }
}`;

export const mutateUpdateAnimal = `mutation MyMutation(
  $AnimalName: String!,
  $Administration: String,
  $StudyID: String,
  $Stain: String,
  $Sex: String,
  $SacrificePeriod: String,
  $ID: String,
  $Group: String,
  $Dose: String!
) {
  updateAnimal(
    animal:{
      AnimalName: $AnimalName, 
      Administration: $Administration, 
      StudyID: $StudyID, 
      Stain: $Stain, 
      Sex: $Sex, 
      SacrificePeriod: $SacrificePeriod, 
      Group: $Group
      Dose: $Dose
      ID: $ID
    }
  ) {
    Administration
    AnimalName
    Dose
    Group
    SacrificePeriod
    ID
    Sex
    Stain
    StudyID
    Slides {
      AnimalID
      Block
      ControlGroup
      Dzi
      ID
      ImageFileName
      Magnification
      Organ
      Scanner
      Set
      SlideName
      InterimSlideNote {
        Directionality
        Finding
        FindingInhand
        ID
        Laterality
        ServerityInhand
        Severity
        SlideID
      }
      SlideNote {
        Directionality
        Finding
        FindingInhand
        ID
        Laterality
        ServerityInhand
        Severity
        SlideID
      }
      SlideStatus
      StudyID
      SlideObservation {
        Directionality
        Finding
        FindingInhand
        ID
        Laterality
        ServerityInhand
        Severity
        SlideID
      }
    }
  }
}`;

export const delAnimal = `mutation MyMutation($id: String!){
  deleteAnimal(id: $id) {
    Administration
    AnimalName
    Dose
    Group
    ID
    SacrificePeriod
    Sex
    StudyID
    Stain
  }
}`;

export const getAnimal = `query MyQuery($id: String!) {
  getAnimal(id: $id) {
    Administration
    AnimalName
    Dose
    Group
    ID
    SacrificePeriod
    Sex
    Stain
    StudyID
    Slides {
      AnimalID
      Block
      ControlGroup
      Dzi
      ID
      ImageFileName
      Magnification
      Organ
      Scanner
      Set
      SlideName
      StudyID
      SlideStatus
    }
  }
}`